import gql from 'graphql-tag'

export const fragment = gql`
fragment clientTree on CA_Query {
    children: clientTree {
        id
        mod_ver
        name
        children: regions {
            id
            mod_ver
            name
            children: shops {
                id
                mod_ver
                name
                children: cashRegisters(includeOutOfOrder: $includeOutOfOrder) {
                    id
                    mod_ver
                    name
                    hardwareId
                    deviceType
					tseRemoteCashRegisterId
                    outOfOrder
                }
            }
        }
    }
}`

const query = gql`
query clientTree($includeOutOfOrder: Boolean) {
    cashAssist {
        ...clientTree
    }
}
${fragment}
`

export default query
